import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { CompanyService } from '../../services/CompanyService/company';
import { CompanyResponse } from '../../models/company.dto';
import { extractErrorMessage } from '../../shared/error-utils';
import { StatusBadge } from '../../shared/components/status-badge/status-badge';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

@Component({
  selector: 'app-my-company',
  imports: [CommonModule, StatusBadge, ErrorBanner],
  templateUrl: './my-company.html',
  styleUrl: './my-company.scss',
})
export class MyCompany implements OnInit {
  company = signal<CompanyResponse | null>(null);
  isLoading = signal(false);
  errorMessage = signal('');

  constructor(private companyService: CompanyService) {}

  ngOnInit(): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.companyService.me().subscribe({
      next: (res) => {
        this.isLoading.set(false);
        this.company.set(res.data);
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to load your company.'));
      },
    });
  }
}
